import { useTranslation } from "react-i18next";
import { CheckIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ConfirmationModal } from "../../ConfirmationModal";
import { IncomeSource } from "../../../models/IncomeSource";

interface Props {
    info: {
        show: boolean;
        income?: IncomeSource;
    };
    onClose: () => void;
    deleteIncome: (income: IncomeSource) => void
}

export const DeleteClientIncomeModal: React.FC<Props> = ({
    info,
    onClose,
    deleteIncome
}) => {

    const { t } = useTranslation();

    const onDeleteIncome = () => {
        deleteIncome(info.income!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_INCOME_SOURCE")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteIncome }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_INCOME_SOURCE_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}